import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { decryptData} from "../../resources/constants";
import { toast } from "react-toastify";
import { serverLink } from "../../resources/url";
import { useLocation, useNavigate } from "react-router-dom";
import { setApplicationDetails, setLoginDetails } from "../../actions/actions";
import Loader from "../common/loader/loader";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const LoginFromStaff = (props) => {
    const navigate = useNavigate();
    let query = useQuery();
    const email_address = decryptData(query.get("email"));
    const password = query.get("password");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        props.setOnLoginDetails("");
        props.setOnApplicationDetails("");
    }, []);


    const handleLogin = async (e) => {
        const sendData = {
            Password: password,
            EmailAddress: email_address
        }
        await axios
            .post(`${serverLink}application/login`, sendData)
            .then((response) => {
                const data = response.data;
                if (data.message === "success") {
                    toast.success("Login Successful. Please wait...");
                    const dateOfBirth = data.data[0].DateOfBirth.split("T")[0];
                    const sendData = {
                        ...data.data[0],
                        DateOfBirth: dateOfBirth,
                    };
                    setTimeout(() => {
                        props.setOnLoginDetails(sendData);
                        // navigate('/application')
                        window.location.href = '/application';
                    }, 2000);
                } else {toast.error("Invalid login credential!"); navigate("/")
}
            })
            .catch((error) => {
                toast.error("Network error. Check your connection and try again!");
            });
    };

    useEffect(() => {
        if (query.get("email") && query.get("password")) {
            handleLogin();
        } else {
            setLoading(false);
            console.log("Query parameters missing or invalid");
        }
    }, []);

    return loading ? (
        <Loader />
    ) : (
        <>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnApplicationDetails: (p) => {
            dispatch(setApplicationDetails(p));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginFromStaff);

